import {
    getAltezzaHighIndex,
    getSeoSelfServiceData,
    seoSelfServiceDataProcessor,
} from '@/utilities/context-middleware/withSelfServiceSeoHelpers';

import srpContentDuck from '@/ducks/srp/srpContentDuck.js';

export default function withSelfServiceSeo() {
    return async (ctx) => {
        const {
            brand: [, { seo_query_id: seoQueryId }],
            srp_seo_self_serv: [enableSrpSeoSelfService],
        } = ctx.useFeatures([
            'brand',
            'srp_seo_self_serv',
        ]);
        const brand = ctx?.data?.brand;

        if (enableSrpSeoSelfService && typeof window === 'undefined') {

            ctx.srpHighIndexURLs = await getAltezzaHighIndex(brand);

            const {
                selfServiceSeoCacheDataWithLocation,
                selfServiceSeoCacheDataWithoutLocation,
                selfServiceSeoCacheIdWithoutLocation,
            } = await getSeoSelfServiceData(ctx, seoQueryId);

            if (selfServiceSeoCacheDataWithLocation && Object.keys(selfServiceSeoCacheDataWithLocation).length > 0) {
                await seoSelfServiceDataProcessor(ctx, brand, true, selfServiceSeoCacheDataWithLocation);
            } else if (selfServiceSeoCacheDataWithoutLocation && Object.keys(selfServiceSeoCacheDataWithoutLocation).length > 0) {
                await seoSelfServiceDataProcessor(ctx, brand, false, selfServiceSeoCacheDataWithoutLocation);
            } else {
                ctx.srpSelfServiceSeo = {
                    id: selfServiceSeoCacheIdWithoutLocation,
                };
            }

            ctx.store.dispatch(srpContentDuck.creators.setKeys({
                srpSelfServiceSeo: ctx.srpSelfServiceSeo,
                srpHighIndexURLs: ctx.srpHighIndexURLs,
            }));
        }
    };
}
